const footerCtaContainer = document.querySelector('.FooterCTA__popup-container');

function shouldChangeHeader(btnClicked) {
    if (btnClicked.closest('.wp-block-kadence-advancedbtn')?.classList.contains('open-popup-btn')) {
        const popupHeading = document.querySelector('.FooterCTA__heading');
        popupHeading.innerText = 'Złóż zapytanie';
    }
}

if (footerCtaContainer) {
    const openBtns = document.querySelectorAll('.FooterCTA__btn, .open-popup-btn a');
    const closeBtn = document.querySelector('.FooterCTA__popup-close-btn');

    openBtns?.forEach((openBtn) => {
        openBtn.addEventListener('click', (e) => {
            e.preventDefault();

            shouldChangeHeader(openBtn);

            footerCtaContainer.classList.add('active');
            document.documentElement.style.overflowY = 'hidden';
        });
    });

    closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        footerCtaContainer.classList.remove('active');
        document.documentElement.style.overflowY = 'auto';
    });
}
